import { render, staticRenderFns } from "./StudentLogbooks.vue?vue&type=template&id=0e1a24f2&"
import script from "./StudentLogbooks.vue?vue&type=script&lang=js&"
export * from "./StudentLogbooks.vue?vue&type=script&lang=js&"
import style0 from "./StudentLogbooks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports